import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import NewClient from "../Items/NewClient";
import useAuthHelper from "../../helpers/AuthHelper";
import Client from "../../components/Client";
/**
 * create new Incoice
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const DevisEdit = () => {
  const { onlyCommercial } = useAuthHelper();

  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);

  const [productId, setProductId] = useState();
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);

  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  let invoiceProducts = [];
  const [totalTTc, setTotalTTC] = useState();
  const [isService, setIsService] = useState(false);

  //useRef
  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [prdctData, setPrdctData] = useState();

  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;
  const date_now = new Date();
  const [client, setClient] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [objet, setObjet] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [lastInvoiceNumber, setLastInvoiceNumber] = useState(0);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);
  const [dataDevis, setDataDevis] = useState([]);

  const [selectedDepotId, setSelectedDepotId] = useState(null);
  const [depotsProduct, setDepotsProduct] = useState([]);
  const MAX_TITLE_LENGTH = 255;

  useEffect(() => {
    onlyCommercial();

    console.log("tchanga", invoiceProductsState);
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);

  const getAllAssociatedClients = async () => {
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
          $("#warning-create-client-first").css("display", "block");
        } else {
          $("#warning-create-client-first").css("display", "none");
          setClients(transformClientsArray(response.data.data));
          console.log("lcintes : ", clients);
          /**
           * {
           *     "value": 56,
           *     "label": "Commodi minus omnis Ipsum ullam architec"
           * }
           */
        }
      })
      .catch((error) => console.log("error " + error));
  };

  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformProductsArray(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };

  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = {
        value: clients[i].id,
        label: clients[i].companyName,
      };
      array.push(obj);
    }
    return array;
  };

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;
    // {
    //     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
    //     "qty": "1",
    //     "unitPrice": 100,
    //     "tva": 20,
    //     "totalHt": "100",
    //     "totalTtc": "120"
    // },
    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewProductToInvoice = async () => {
    // Vérification des champs requis
    if (!singleSelectedProduct.value || qty === 0) {
      $("#all-fields-are-required").css("display", "block"); // Afficher l'avertissement si les champs sont manquants
    } else {
      hideOffcanvas(); // Fermer le offcanvas/modal de sélection de produit
      $("#all-fields-are-required").css("display", "none"); // Cacher l'avertissement de champs requis

      // Vérifie si le produit existe déjà dans la liste
      const productExists = invoiceProductsState.find(
        (prd) => prd.id === singleSelectedProduct.value,
      );

      if (productExists) {
        $("#warning-product-already-exists").css("display", "block"); // Afficher l'avertissement que le produit existe déjà
      } else {
        $("#warning-product-already-exists").css("display", "none"); // Cacher l'avertissement que le produit existe déjà

        // Prépare l'objet produit
        let product = {
          id: singleSelectedProduct.value, // Utilise l'ID du produit
          name: singleSelectedProduct.label, // Utilise le nom du produit
          qty: qty, // Quantité
          unitPrice: unitPrice, // Prix unitaire
          tva: tva, // Taxe (TVA)
          totalHt: leTotalHt.current.value, // Total hors taxe
          totalTtc: leTotalTTc.current.value,
          depot_id: selectedDepotId, // Total TTC
          depots: depotsProduct, // Détails du dépôt
        };

        // Ajoute le produit à la liste
        invoiceProducts.push(product);

        // Met à jour l'état avec la nouvelle liste de produits
        setInvoiceProductsState([...invoiceProductsState, product]);
        console.log(invoiceProductsState);
      }
    }
  };

  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const getProductData = async (selectedProduct) => {
    // Met à jour la quantité du produit sélectionné
    // setSelectedProductQty(selectedProduct.qty);

    try {
      const response = await axios.get(
        `${baseURL}/product/get/${selectedProduct.value}`,
      );

      // Vérifie si la réponse est valide et contient des données
      if (response.data.data && response.data.data.length > 0) {
        const productData = response.data.data[0]; // Premier élément du tableau
        setUnitPrice(productData.sellingPrice); // Définit le prix unitaire
        console.log("Données du produit :", productData);

        // Vérifie si le type du produit est un service
        if (productData.type === "Services") {
          setIsService(true);
          setQty(1); // Quantité pour les services
        } else {
          setIsService(false);
          setQty(0); // Quantité pour les autres produits
        }
        setDepotsProduct(productData.depot);

        // Met à jour la TVA selon les informations du produit
        setTva(productData.taxe_vente?.rate || 0);
      }
    } catch (error) {
      console.log(
        "Erreur lors de la récupération des données du produit :",
        error,
      );
    }
  };

  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = {
        value: products[i].id,
        label: products[i].name,
        unit_price: products[i].sellingPrice,
      };
      array.push(obj);
    }
    return array;
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedClients();
    getAllAssociatedProducts();
    getInvoiceStatus();
    getallDataDevis();
  }, []);
  const getInvoiceStatus = async () => {
    const response = await jwtInterceoptor
      .get("data/user/status/devis")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };

  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let selectedProduct = [];
    selectedProduct = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );
    console.log("selected product on click edit: ", selectedProduct[0]);
    setIsService(selectedProduct[0].type === "Services");
    setTva(selectedProduct[0].tva);
    setQty(selectedProduct[0].qty);
    setUnitPrice(selectedProduct[0].totalHt / selectedProduct[0].qty);
    setTotalHt(selectedProduct[0].totalHt);
    setTotalTTC(selectedProduct[0].totalTtc);
    setSelectedDepotId(selectedProduct[0].depot_id);
    setDepotsProduct(selectedProduct[0].depots);
  };
  const editSingleInvoiceProduct = () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0
    ) {
      toast.warning(t("Tous les champs sont obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      //$("#all-fields-are-required").css('display', 'block');
    } else {
      $("#all-fields-are-required").css("display", "none");
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };
  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
    setSelectedDepotId(0);
    setDepotsProduct([]);
    setIsService(false);
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/devis/last/" + organisation.id)
      .then((res) => {
        if (res.data.data !== null) {
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };

  const save = () => {
    if (objet.trim().length > MAX_TITLE_LENGTH) {
      toast.error(
        t(`Le titre ne doit pas dépasser ${MAX_TITLE_LENGTH} caractères.`),
        {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        },
      );
      return;
    }
    if (
      client.value === undefined ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      invoiceProductsState.length === 0 ||
      selectedStatus === 0
    ) {
      toast.error("Tous les champs sont obligatoires !", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
      });
    } else {
      let preparedProducts = [];

      // Prepare the products array
      for (let i = 0; i < invoiceProductsState.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoiceProductsState[i].id,
          price_unit_ht: invoiceProductsState[i].unitPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].totalHt,
          total_ttc: invoiceProductsState[i].totalTtc,
          tva: invoiceProductsState[i].tva,
          reference: ref,
          depot_id: invoiceProductsState[i].depot_id, // Depot ID
        };
        preparedProducts.push(obj);
      }

      // Prepare the object to send in the PATCH request
      const prepareObject = {
        user_id: user.id,
        organisation_id: organisation.id,
        client_id: client.value,
        total_ht: summaryTotatlHt,
        total_ttc: summaryTotatlTtc,
        total_tva: summaryTotalTva,
        title: objet,
        due_date: invoiceDueDate,
        created_at_date: invoiceCreatedAt,
        status: selectedStatus,
        payed_amount: payedAmount,
        products: preparedProducts,
      };

      // Call saveInvoice to make the PATCH request
      saveInvoice(prepareObject, id); // Pass the id of the 'Devis' to be updated
    }
  };

  // Function to make the PATCH request
  const saveInvoice = async (invoice, id) => {
    setIsSubmit(true);
    try {
      console.log("data Env", invoice);
      const response = await jwtInterceoptor.patch(
        `${baseURL}/data/user/devis/byid/${id}`,
        invoice,
      );
      setIsSubmit(false);
      Swal.fire("Le devis a été modifié avec succès", "", "success");
      navigate("/sales/devis/list");
    } catch (error) {
      setIsSubmit(false);
      console.log("Error while saving", error);
    }
  };

  const onSaveClient = () => {
    getAllAssociatedClients();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le client a été ajouter avec succès"), t(""), "success");
  };
  let { id } = useParams();
  console.log("id", id);

  // Function to convert MM/DD/YYYY to YYYY-MM-DD (if needed)
  const convertToISODate = (dateString) => {
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  // Transform the products array
  const transformProducts = (products) => {
    return products.map((product) => {
      return {
        id: product.product_id, // Product ID
        name: product.product.name, // Product name
        qty: product.qty, // Quantity
        unitPrice: product.price_unit_ht, // Unit price
        tva: product.tva, // TVA
        totalHt: product.total_ht, // Total HT
        totalTtc: product.total_ttc, // Total TTC
        type: product.product.type,
        depot_id: product.depot_id, // Depot ID
        depots: product.product.depot, // Depot details
      };
    });
  };

  const formatDateForInput = (isoDate) => {
    return isoDate ? isoDate.split("T")[0] : ""; // Split at 'T' to keep only the 'yyyy-MM-dd' part
  };
  const getallDataDevis = async () => {
    try {
      const response = await jwtInterceoptor.get(
        baseURL + `/data/user/devis/byid/${id}`,
      );

      if (response && response.data && response.data.data.length > 0) {
        const devisData = response.data.data[0]; // First devis object in the array

        console.log("response.dataDevis", devisData);

        setDataDevis(devisData); // Store the entire devis data
        let clt = transformClientsArray(devisData.client);
        setClient({ value: devisData.client.id, label: devisData.client.name }); // Set client ID
        console.log("Client selected", client);
        setObjet(devisData.title); // Set title

        // Set created_at and due_date (assuming they are in ISO format)
        setInvoiceCreatedAt(formatDateForInput(devisData.created_at));
        setInvoiceDueDate(devisData.due_date);

        // Set transformed products
        setInvoiceProductsState(transformProducts(devisData.products));
        // set l'etat
        setSelectedStatus(devisData.status);
        console.log("invoiceProduct", invoiceProductsState);
      } else {
        console.error("No data found in response", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching data. Please try again later.");
    }
  };

  // Log updated `invoiceProductsState` using useEffect
  useEffect(() => {
    console.log("Updated invoiceProductsState:", invoiceProductsState);
  }, [invoiceProductsState]);

  return (
    <>
      <ToastContainer />

      <div className="main-container container-fluid">
        <GoBack route="/sales/devis/list" />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">Devis</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/sales/devis/list")}
                >
                  Liste des devis
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Modifier le devis
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0 all-fields-are-required-to-save"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong></strong> Tous les champs sont obligatoire !
                </span>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                class="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="newClientModal">
                        Ajouter un nouveaux client
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <NewClient
                        clientType={"client"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace client")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nom du client*
                    </label>
                    <Select
                      value={client}
                      options={clients}
                      onChange={(choice) => setClient(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nouveau Client
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> ajouter un client
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>Informations sur la facture</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Objet*
                    </label>
                    <input
                      id="invoiceTitle"
                      type="text"
                      placeholder="objet"
                      className="form-control"
                      value={objet}
                      // maxLength={MAX_TITLE_LENGTH}
                      onChange={(e) => setObjet(e.target.value)}
                      aria-invalid={objet.length > MAX_TITLE_LENGTH}
                      aria-describedby="invoice-title-help"
                    />

                    <small
                      id="invoice-title-help"
                      className={
                        objet.length > MAX_TITLE_LENGTH
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      {objet.length}/{MAX_TITLE_LENGTH} caractères maximum
                    </small>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>Les dates</h5>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date de devis*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                      min={firstDayOfYear}
                      max={lastDayOfYear}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date d'échéance*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>
                {t("Produits")}/{t("Services")}
              </h5>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">DÉTAILS DE L’ARTICLE</th>
                    <th scope="col">QUANTITÉ</th>
                    <th scope="col">PU HT</th>
                    <th scope="col">TVA %</th>
                    <th scope="col">Total HT</th>
                    <th scope="col">Total TTC</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invoiceProductsState.map((product) => {
                  /**
                   * [
                   *     {
                   *         "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
                   *         "qty": "1",
                   *         "unitPrice": 100,
                   *         "tva": 20,
                   *         "totalHt": "100",
                   *         "totalTtc": "120"
                   *     },
                   *     {
                   *         "name": "Butterfly Anklet, Charm Anklet, Diamond Butterfly Anklet, Gold Butterfly Anklet, Simple Butterfly Anklet, Gift for Women, Gift for Her",
                   *         "qty": "2",
                   *         "unitPrice": 199,
                   *         "tva": 20,
                   *         "totalHt": "398",
                   *         "totalTtc": "477.6"
                   *     }
                   * ]
                   */
                  return (
                    <tr key={product.product_id}>
                      <td>{product.name}</td>
                      <td>{product.qty}</td>
                      <td>{product.unitPrice}</td>
                      <td>{product.tva + "%"}</td>
                      <td>{product.totalHt}</td>
                      <td>{product.totalTtc}</td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleProduct(product.product_id)
                          }
                          class="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() => editSingleProduct(product.product_id)}
                          class="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  ajouter un article
                </button>
              </center>

              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total HT :</td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TVA :</td>
                          <td>
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TTC :</td>
                          <td>
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Etat*
                    </label>
                    <select
                      className="form-select"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">selectionner L'état du devis</option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <br />
              <div class="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default "
                    style={{ marginRight: 10 }}
                  >
                    Annuler
                  </a>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                    Renseigner le produit à ajouter.
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> Tous les champs sont
                        obligatoire !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> Le produit déja exist !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="qty-is-higher">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        {/* <strong>Attention!</strong>Il ne reste plus que {selectedProductQty}{" "}
                        articles en stock{" "} */}
                        {/* Facture de vente : afficher "Rupture de stock" lorsque le stock disponible est à 0 */}
                        {selectedProductQty === 0 ? (
                          <strong>Rupture de stock</strong>
                        ) : (
                          <>
                            <strong>{"Attention"}!</strong> il réste{" "}
                            {selectedProductQty} articles en stock
                          </>
                        )}
                      </span>
                    </div>
                    <br />
                  </div>

                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          DÉTAILS DE L’ARTICLE*
                        </label>
                        <Select
                          className={"select-article"}
                          value={singleSelectedProduct}
                          options={products}
                          onChange={(choice) => {
                            setQty(0); // Réinitialise la quantité
                            console.log("Produits disponibles :", products);

                            setSingleSelectedProduct(choice); // Définit le produit sélectionné
                            getProductData(choice); // Récupère les données du produit
                            setIsService(choice?.type === "Services"); // Met à jour l'état selon le type
                            console.log("Produit sélectionné :", choice);
                          }}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        {depotsProduct?.length > 0 && (
                          <>
                            <label htmlFor="productDepots">
                              {t("Dépôts disponibles")}
                            </label>
                            {depotsProduct?.map((depot, index) => (
                              <div key={index} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={`depot-${index}`}
                                  value={depot.depot_id}
                                  name="productDepot"
                                  checked={selectedDepotId === depot.depot_id}
                                  onChange={(e) => {
                                    setSelectedDepotId(e.target.value);
                                    setSelectedProductQty(depot.quantity);
                                    console.log("productDepot", e.target.value);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`depot-${index}`}
                                >
                                  {depot.depot.name}
                                </label>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      <div className="col-xl-3 mb-3" hidden={isService}>
                        <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                        <input
                          className="form-control"
                          id="validationTooltip02"
                          type="number"
                          required
                          value={qty}
                          onChange={(e) => {
                            $("#qty-is-higher").css("display", "none");

                            const inputValue = parseFloat(
                              parseFloat(e.target.value).toFixed(2),
                            );

                            if (isNaN(inputValue) || inputValue < 0) {
                              setQty(0);
                              setTotalHt(0);
                              setTotalTTC(0);
                              return;
                            }

                            // Calcule les valeurs
                            const totalHtl = parseFloat(
                              (inputValue * unitPrice).toFixed(2),
                            );
                            const totalTTC = parseFloat(
                              (totalHtl + (totalHtl * tva) / 100).toFixed(2),
                            );

                            // Met à jour l'état
                            setQty(inputValue);
                            setTotalHt(totalHtl);
                            setTotalTTC(totalTTC);
                          }}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">PU HT*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={unitPrice}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (!isNaN(value)) {
                              let total_ht = qty * value;
                              let total_ttc = (
                                parseFloat(total_ht) +
                                (parseFloat(total_ht) * tva) / 100
                              ).toFixed(2);
                              setUnitPrice(parseFloat(value.toFixed(2)));
                              setTotalHt(parseFloat(total_ht.toFixed(2)));
                              setTotalTTC(total_ttc);
                            }
                          }}
                          // disabled={!isService}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total HT*</label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={isService ? unitPrice.toFixed(2) : totalHt}
                          ref={leTotalHt}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total TTC*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={
                            isService
                              ? (
                                  parseFloat(unitPrice.toFixed(2)) +
                                  (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                                ).toFixed(2)
                              : totalTTc
                          }
                          ref={leTotalTTc}
                        />
                      </div>
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewProductToInvoice}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSingleInvoiceProduct}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DevisEdit;
